import { finishAppArrival, APP_ARRIVAL_HASH, } from "coreinfra-ui/app-navigation";
import { fetchProfile } from "../lib/hubApi.js";
import { hubLoginRedirect, takeLoginReturnMark } from "../lib/hubLogin.js";
import { readUiConfig } from "../lib/uiConfig.js";
import { initializeTheme, withTheme } from "coreinfra-ui/theme";
const boot = async () => {
    initializeTheme();
    const root = document.getElementById("app");
    if (!root)
        throw new Error('Missing "#app" root element');
    const { hubOrigin } = readUiConfig();
    const hubLink = root.querySelector("a[data-hub-link]");
    if (hubLink)
        hubLink.href = withTheme(hubOrigin);
    const current = new URL(window.location.href);
    if (current.hash === APP_ARRIVAL_HASH &&
        current.searchParams.get("app_from") === "hub")
        document.getElementById("app-arrival")?.setAttribute("data-active", "");
    const returnedFromLogin = takeLoginReturnMark(current);
    const mount = import("../mount.js");
    mount.catch(() => { });
    let profile;
    try {
        profile = await fetchProfile();
    }
    catch (error) {
        const login = hubLoginRedirect(error, hubOrigin, current, returnedFromLogin);
        if (login)
            window.location.replace(withTheme(login.href));
        else
            finishAppArrival();
        return;
    }
    if (returnedFromLogin) {
        window.history.replaceState(window.history.state, "", current);
    }
    const { mountApp } = await mount;
    mountApp(root, profile);
};
void boot().catch((error) => {
    finishAppArrival();
    console.error("Failed to start the app", error);
});
